module.exports = __webpack_public_path__ + "img/MarcusSchebek-IMG.6a9bbc02.jpg";